export const FETCH_DESTINATIONS = "fetchDestinations";
export const CREATE_DESTINATION = "createDestination";
export const DELETE_DESTINATION = "deleteDestination";
export const UPDATE_DESTINATION = "updateDestination";
export const RESET_DESTINATIONS = "resetDestinations";
